export const STAGES = [
    { label: 'Prospecção', value: 'prospeccao' },
    { label: 'Abordagem', value: 'abordagem' },
    { label: 'Apresentação', value: 'apresentacao' },
    { label: 'Follow Up', value: 'followUp' },
    { label: 'Negociação', value: 'negociacao' },
    { label: 'Fechamento', value: 'fechamento' },
];

export const ONDE_NOS_CONHECEU = [
    { value: 'google', label: 'Google' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'tiktok', label: 'Tiktok' },
    { value: 'youtube', label: 'YouTube' },
    { value: 'site', label: 'Site' },
    { value: 'blog', label: 'Blog' },
    { value: 'feiras_eventos', label: 'Feiras e Eventos' },
    { value: 'congressos', label: 'Congressos' },
    { value: 'jornal_revistas', label: 'Jornal e Revistas' },
    { value: 'indicacao', label: 'Indicação' },
    { value: 'parceria', label: 'Parceria' },
    { value: 'outro', label: 'Outro' },
];